import React from 'react';
import ReactDOM from 'react-dom/client';
import Tracker from '@openreplay/tracker';
import './index.css';
import App from './App';

const openReplayKey = import.meta.env.VITE_OPENREPLAY_PROJECT_KEY;
if (openReplayKey) {
    const tracker = new Tracker({
        projectKey: openReplayKey,
        // Type assertion needed: SDK type defs have a name-collision bug on NetworkOptions
        network: {capturePayload: true} as any,
    });
    tracker.start();
    (window as any).__openReplayTracker = tracker;

    // Identify session by client IP; fall back to random UUID if the call fails
    fetch('/api/client-ip')
        .then(r => r.json())
        .then(data => tracker.setUserID(data.ip))
        .catch(() => {
            const storageKey = 'sb_anonymous_uid';
            let uid = localStorage.getItem(storageKey);
            if (!uid) {
                uid = crypto.randomUUID();
                localStorage.setItem(storageKey, uid);
            }
            tracker.setUserID(uid);
        });
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);
